import { useEffect, useState } from "react";
import { NotesTableV3 } from "@/entities/notes-table-v3";
import { useContainerSize } from "@/shared/hooks";
import { DEFAULT_NOTE_TYPES_LABELS } from "@/services/api";
import type { FC } from "react";
import { NoNotesWidget } from "../NoNotesWidget";
import { useDashboardsNotesTable } from "../../lib";
import styles from "./styles.module.scss";

type Props = {
  widgetId?: string;
};

export const DashboardsNotesTable: FC<Props> = ({ widgetId }) => {
  const { state, methods } = useDashboardsNotesTable({ widgetId });
  const { columns, dataSource, isLoading } = state;
  const { onRowClick } = methods;
  const { containerRef, containerHeight } = useContainerSize({});
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [containerHeight]);

  if (!dataSource.length) {
    return <NoNotesWidget widgetNoteType={DEFAULT_NOTE_TYPES_LABELS.DEFAULT_NOTE} />;
  }

  return (
    <div ref={containerRef} className={styles.container}>
      <NotesTableV3
        key={key}
        virtual
        onRow={(record) => ({ onClick: () => onRowClick(record) })}
        scroll={{ y: containerHeight - 105, x: "max-content" }}
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        isPaginationVisible={false}
      />
    </div>
  );
};
